import * as actions_key from '../actions/data';

const initialState = {};


const dataReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions_key.FETCH_DATA:
            return {
                ...action.payload
            };
        case actions_key.FETCH_PERSONAL_INFO:
            return {
                ...state, ...action.payload
            };
        case actions_key.FETCH_SOCIAL_NETWORKS:
            return {
                ...state, ...action.payload
            };
        case actions_key.FETCH_IMAGES_PRINCIPAL:
            return {
                ...state, ...action.payload
            };
        case actions_key.FETCH_POSTS:
            return {
                ...state, ...action.payload
            };
        case actions_key.FETCH_RELATED_POSTS:
            return {
                ...state, ...action.payload
            };
        case actions_key.FETCH_POST_BY_TITLE:
            return {
                ...state, ...action.payload
            };
        case actions_key.FETCH_POST_IMAGES:
            return {
                ...state, ...action.payload
            };
        case actions_key.FETCH_TYPES_POSTS:
            return {
                ...state, ...action.payload
            };
        case actions_key.FETCH_SKILLS:
            return {
                ...state, ...action.payload
            };
        case actions_key.FETCH_LENGUAGES:
            return {
                ...state, ...action.payload
            };
        case actions_key.FETCH_EXPERIENCE:
            return {
                ...state, ...action.payload
            };
        case actions_key.FETCH_EDUCATION:
            return {
                ...state, ...action.payload
            };
        case actions_key.PUT_DATA:
            return {
                ...action.payload
            };
        case actions_key.DELETE_PRODUCT:
            const deletedProducts = { ...state.products };
            deletedProducts.products[action.payload.indexTypeProduct].productsList[action.payload.indexProduct] = { ...action.payload.updatedProduct };
            return {
                ...state, products: deletedProducts
            };
        case actions_key.UPDATE_PRODUCT:
            const updatedProducts = { ...state.products };
            updatedProducts.products[action.payload.indexTypeProduct].productsList[action.payload.indexProduct] = { ...action.payload.updatedProduct };
            return {
                ...state, products: updatedProducts
            };
        case actions_key.UPDATE_CONTACT:
            const updatedContact = { ...state.generalProps };
            updatedContact.contactScreen.contactList[action.payload.indexItemContact] = { ...action.payload.updatedItem };
            return {
                ...state, generalProps: updatedContact
            };
        case actions_key.UPDATE_ABOUT:
            const updatedAbout = { ...state.about };
            if (action.payload.indexItemToUpdate === false) {
                updatedAbout[action.payload.indexType] = action.payload.updatedItem;
            } else {
                updatedAbout[action.payload.indexType][action.payload.indexItemToUpdate] = { ...action.payload.updatedItem };
            }
            return {
                ...state, about: updatedAbout
            };
        case actions_key.UPDATE_PRODUCT_FEATURE:
            const productsOld = { ...state.products };
            productsOld[action.payload.indexType][action.payload.indexItemToUpdate] = { ...action.payload.updatedItem };
            return {
                ...state, products: productsOld
            };
        default:
            return state;
    }
};

export default dataReducer;